// import { Component } from '@angular/core';
// import { LottieLoaderService } from './../app/mastermodule/service/lottie-loader.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: 'app.component.html',
//   styleUrls: ['app.component.scss'],
// })
// export class AppComponent {
//  isLoading = false;

//   constructor(private loaderService: LottieLoaderService) {
//     this.loaderService.isLoading$.subscribe((loading) => {
//       this.isLoading = loading;
//     });
//   }
// }


// src/app/app.component.ts
import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LottieLoaderService } from './../app/mastermodule/service/lottie-loader.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  showLoader = false;

  constructor( private router: Router,private loaderService: LottieLoaderService)  {
    this.loaderService.loaderState.subscribe(val => {
      this.showLoader = val;
    });

    // Show loader during navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loaderService.hide();
      }
    });
  }
}
